









import { Component, Prop, Vue } from 'vue-property-decorator';
@Component
export default class FieldControl extends Vue {
  @Prop({ type: String, required: true }) errorText!: string;
  @Prop({ type: Boolean, default: false }) isError!: boolean;
}
